// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NotificationActiveIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="NotificationActiveIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M6.279 3.696c-.463.186-1.04.642-1.505 1.278C4.312 5.606 4.024 6.329 4.024 7h-1.5c0-1.079.45-2.105 1.039-2.911.586-.802 1.371-1.47 2.158-1.785z" />
      <path d="M15.24 4.977c-.47-.636-1.053-1.095-1.518-1.28l.556-1.393c.785.314 1.577.98 2.169 1.782C17.042 4.89 17.5 5.918 17.5 7H16c0-.668-.291-1.39-.76-2.023" />
      <path d="M14.49 8.486a4.5 4.5 0 0 0-3.494-4.374V2.5H9v1.61a4.5 4.5 0 0 0-3.503 4.387v3.999l-1.494.501H4V14.5h12V13l-.003-.002-1.497-.501zM7 11.498H6.997V8.497a2.997 2.997 0 0 1 5.993-.008l.007 2.95H13v1.56H7z" />
      <path d="M9 16v2h1.996v-2z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const NotificationActiveIcon = /* @__PURE__ */ Object.assign(
  NotificationActiveIconComponent,
  { displayName: 'NotificationActiveIcon' },
);
